import React from 'react'
import { NavLink } from 'react-router-dom'
import { FiArrowUpRight } from 'react-icons/fi'
import '../layouts/stylesheets/table.css'

const DashboardIcon = (props) => {
  return (
    <NavLink
      to={'/campaign-overview/' + props.id}
      className="inline-flex items-center border-gray-300 hover:bg-gray-50 transition px-4 py-3"
    >
      <FiArrowUpRight className="text-[#FAD070] text-xl" />
      <span className=" text-[#BBA268] underline underline-offset-4 tracking-wide font-unbounded">
        EXPLORE
      </span>
    </NavLink>
  )
}

export default DashboardIcon
